<template>
    <CardPage :section="16" :page="5" :nextDisabled="nextDisabled" ref="cardPage">
        <div>
            <p class="font-weight-bold" v-if="!allThreatsAnswered">
                <v-fade-transition mode="out-in">
                    <span :key="threats[threatsOrder[currentThreat]].text">{{ threats[threatsOrder[currentThreat]].text }}</span>
                </v-fade-transition>
            </p>
            <p v-else class="font-weight-bold font-italic">You've matched all the substance impacts!</p>
            <div
                v-for="(substance, index) in substances"
                :key="index"
                class="grey lighten-3 pa-3 mb-1"
                :class="{ success: isSelected(substance) }"
                @click.stop="answer(substance)"
                v-ripple
            >
                {{ substance }}
            </div>
            <div class="empty-height font-italic text-xs-center">
                <span v-if="pickOneMore">(pick another)</span>
            </div>
        </div>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import { includes } from 'lodash';

export default {
    data() {
        return {
            pickOneMore: false
        };
    },
    computed: {
        threats: get('section16/threats'),
        threatsOrder: get('section16/threatsOrder'),
        currentThreat: get('section16/currentThreat'),
        allThreatsAnswered: get('section16/allThreatsAnswered'),
        substances: get('section16/substances')
    },
    methods: {
        isSelected(substance) {
            let current = this.threats[this.threatsOrder[this.currentThreat]];
            return current && includes(current.answers, substance);
        },
        answer(substance) {
            if (this.allThreatsAnswered) {
                return;
            }

            let current = this.threats[this.threatsOrder[this.currentThreat]];
            let currentIndex = this.currentThreat;

            if (includes(current.correctAnswers, substance)) {
                this.$refs.modalFeedback.show(true, 'Great job!', () => {
                    this.$store.commit('section16/answerThreat', substance);

                    this.pickOneMore = this.currentThreat === currentIndex;

                    if (!this.nextDisabled()) {
                        this.$refs.cardPage.nextClick();
                    }
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Try again!');
            }
        },
        nextDisabled() {
            return !this.allThreatsAnswered;
        }
    }
};
</script>
